import axios from './axios'
import { Patient  } from '@/../../EshJSLib/models/patient'
import {File  } from '@/../../EshJSLib/models/patient'

let headers = { headers: { 'content-type': 'multipart/form-data' } }

export async function saveFile(params:File) {
    const response = await axios.post(`/api/files`,params);
    return response;
}

export async function updateFile(params: File) {
    
    const response = await axios.put(`/api/files/${params.id_file}`,params);
    return response.data;
}

export async function deleteFile(id: number) {
const response = await axios.delete(`/api/files/${id}`);
console.log(response);
 return response;
}

export async function getUrl(id: number) {
    const response = await axios.get(`/api/getDRoute/${id}`);
    return response;
}


